import React, { ReactNode } from 'react';

import { IconWarningSign } from '..';

interface Props {
    children: ReactNode;
}

export const Warning = ({ children }: Props): JSX.Element => (
    <div className="bg-quinary-400 py-2 pl-2 pr-8 rounded w-auto inline-block">
        <IconWarningSign fillColor="white" addClasses="inline" />
        <span className="pl-2 text-sm font-bold">{children}</span>
    </div>
);
